module.exports = __webpack_public_path__ + "img/couples-034.bb9a8707.jpg";